<template>
    <div class="shadow-off pt-2 pb-0 pl-0 pr-0" v-if="fifoalaysis">
        <v-row>
            <v-col>
                <div data-testid="transaction-matching-config-new__fifo-section" class="mt-4">
                    <div data-testid="transaction-matching-config-new__fifo-controls" class="d-flex mb-3">
                        <v-spacer></v-spacer>
                        
                        <v-btn data-testid="transaction-matching-config-new__run-fifo-button" color="primary" class="ml-2 shadow-off " @click="$emit('startRunFifo')">
                            <span>Run FIFO</span>
                        </v-btn>
                        <v-btn data-testid="transaction-matching-config-new__fifo-execution-result-button" color="primary" class="ml-2 mr-2 shadow-off " @click="$emit('startRunFifoExecution')">
                            <span>FIFO Execution Result</span>
                        </v-btn>
                            <v-btn data-testid="transaction-matching-config-new__fifo-download-excel-button" color="secondaryBtn" class="mr-2 shadow-off" @click="$emit('downloadResult', 'FIFO')">
                            <v-icon data-testid="transaction-matching-config-new__fifo-download-excel-icon" class="mr-1">mdi-file-excel</v-icon><span>Download Excel</span>
                        </v-btn>
                        <div data-testid="transaction-matching-config-new__fifo-pagination" class="radius-on border-on mb-2 ml-2" v-if="pagecountfifo > 1 && !loading">
                            <v-btn data-testid="transaction-matching-config-new__fifo-prev-page" icon :disabled="pagefifo === 1" @click="$emit('update:pagefifo', pagefifo - 1)">
                                <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>
                            <span data-testid="transaction-matching-config-new__fifo-page-info" class="mx-1">Page {{ pagefifo }} of {{ pagecountfifo }}</span>
                            <v-btn data-testid="transaction-matching-config-new__fifo-next-page" icon :disabled="pagefifo === pagecountfifo" @click="$emit('update:pagefifo', pagefifo + 1)">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                        </div>
                    </div>

                    <div data-testid="transaction-matching-config-new__fifo-table" class="" v-if="items.length > 0">
                        <v-simple-table dense class="border-on" :fixed-header="true">
                            <template v-slot:default>
                                <thead class="tableHeaderBg">
                                    <tr class="tableHeaderBg">
                                        <th data-testid="transaction-matching-config-new__fifo-select-all-header" class="tableHeaderBg name-column" id="select">Select All
                                            <span class="ml-1">
                                                <input data-testid="transaction-matching-config-new__fifo-select-all-checkbox" type="checkbox" :checked="selectallfifo" @change="onToggleSelectAll" />
                                            </span>
                                        </th>
                                        <template v-for="(v, k) in items[0]">
                                            <th data-testid="transaction-matching-config-new__fifo-header" class="tableHeaderBg" :key="k" v-if="k !== '_id'" :id="'automation-test-'+k">
                                                {{ (k || "").replaceAll("_", " ") }}
                                            </th>
                                        </template>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr data-testid="transaction-matching-config-new__fifo-row" v-for="(v, k) in items" :key="k" :id="'automation-test-'+k">
                                        <td>
                                            <input data-testid="transaction-matching-config-new__fifo-row-checkbox" type="checkbox" :value="k" multiple :id="'automation-test-'+k" :checked="selectFifo.includes(k)" @change="updateSelection(k, $event)">
                                        </td>
                                        <template v-for="(vv, kk) in items[0]">
                                            <td :key="kk" v-if="kk !== '_id'" :id="'automation-test-'+k">
                                                {{ typeof v[kk] === "number" ? $nova.formatNumber(v[kk].toFixed(0)) : v[kk] }}
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </div>
                    <div data-testid="transaction-matching-config-new__fifo-empty-state" v-else class="text-center grey--text title pa-6">
                        No data available
                    </div>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'StepFifoAnalysis',
    props: {
        fifoalaysis: Boolean,
        loading: Boolean,
        pagecountfifo: Number,
        pagefifo: Number,
        selectallfifo: Boolean,
        selectFifo: Array,
        items: Array // Pass the computed items (pageItemsfifo) here 
    },
    methods: {
        onToggleSelectAll(event) {
            this.$emit('update:selectallfifo', event.target.checked);
            this.$emit('toggleSelectAll', event.target.checked);
        },
        updateSelection(key, event) {
             let newSelection = [...this.selectFifo];
             if (event.target.checked) {
                 newSelection.push(key);
             } else {
                 const index = newSelection.indexOf(key);
                 if (index > -1) {
                     newSelection.splice(index, 1);
                 }
             }
             this.$emit('update:selectFifo', newSelection);
        }
    }

}
</script>